import React from 'react'
import PropertyTours from '../PropertyTours'

function OpenHouses(props) {
  const isSunday = new Date().getDay() === 0

  return (
    <PropertyTours {...props} pathname="/open-houses" isSunday={isSunday} />
  )
}

export default OpenHouses



// WEBPACK FOOTER //
// ./src/views/OpenHouses/index.js